let order = require('../../actions/order');
let analytics = require('../../actions/analytics');
let price = require('../../actions/order/price');
let orderGroups = require('../groups/order');
let utils = require('../../actions/utils');
let utilsSignals = require('../utils');
let redirect = require('../../actions/redirect');
let error = require('../../actions/error');
let content = require('../../actions/layout/content');
let user = require('../../actions/user');
let customOrder = require('../../actions/custom-order');
let accountOrder = require('../../actions/account/current-order');

module.exports = {
    onLoad: [
        ...utilsSignals.checkCookieEnabled,
        price.initPrice,
        ...orderGroups.startRestoringSelectedParams,
        customOrder.setShouldPersistToLocalStorage(true),
        [
            order.shouldRestoreFromLocalStorage,
            {
                yes: [
                    ...orderGroups.initSelectedParamsFromLocalStorageGroup
                ],
                no: []
            }
        ],
        price.setIsLoading(false),
        content.setIsLoading(false),
        utils.unset(['order', 'tooltip', 'hideDataChangeTooltip']),
        [
            utils.isPage('account'),
            {
                yes: [
                    accountOrder.setPriceFromOrder
                ],
                no: []
            }
        ]
    ],

    onMakeOrderUnauthorized: [
        order.setShouldCreateOrderAfterLogin(true),
        [
            utils.isEqual(['bitrix', 'isBitrix'], true),
            {
                yes: [ redirect.redirect('/registration/extra') ],
                no: [ redirect.redirect('/login') ]
            }
        ]
    ],

    onCreateOrder: [
        content.setIsLoading(true),
        [
            user.isUnauthorized,
            {
                yes: [
                    utils.setArg('category', 'open_order_page_local_draft'),
                    utils.setArg('action', 'click'),
                    analytics.raiseArgsValueEvent,
                    redirect.redirect('/account/orders?showLocal=true')
                ],
                no: [
                    order.getSelectedParamsFromState,
                    {
                        success: [
                            order.fillOrderCreationParameters,
                            [
                                order.createOrder,
                                {
                                    success: [
                                        order.removeSavedSelectedParams,
                                        order.orderCreatedRedirect
                                    ],
                                    unauthorized: [
                                        order.setShouldCreateOrderAfterLogin(true),
                                        redirect.redirect('/login')
                                    ],
                                    error: [
                                        order.setShouldCreateOrderAfterLogin(false),
                                        error.internalError('order.createOrder')
                                    ]
                                }
                            ]
                        ]
                    }
                ]
            }
        ],
        content.setIsLoading(false)
    ],

    onReset: [
        ...orderGroups.resetDraftGroup
    ],

    showTooltip: [
        utils.set(['order', 'price', 'tooltipIsShow'], true)
    ],

    hideTooltip: [
        utils.unset(['order', 'price', 'tooltipIsShow'])
    ],

    clickCostButton: [
        utils.scrollTop
    ],

    tryRaiseCreateOrderWithFilterMap: [
        [
            customOrder.isTabSelected('map'),
            {
                yes: [
                    utils.setArg('category', 'create_order_with_filter_map'),
                    utils.setArg('action', 'click'),
                    analytics.raiseArgsValueEvent
                ],
                no: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/order/index.js